import type { HelpFile } from '../../types/help'
import { FieldPaletteTestIds } from '../../../testids/FieldPaletteTestIds'

export const fieldPaletteHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FieldPaletteTestIds.paletteRetryBtn]: 'Feldpalette neu laden, nachdem das Abrufen der verfügbaren Attribute fehlgeschlagen ist.',
  },
}
